<template>
  <Modal v-if="visible" :value="true" @input="closeModal">
    <div slot="header">
      Configurar o tipo da Coluna
    </div>

    <label for="">Escolha do tipo</label>
    <select v-model="currentField.type" class="form-control">
      <option v-for="type in types" :key="type.value" :value="type.value">
        {{ type.label }}
      </option>
    </select>

    <hr>

    <h3>Propiedadade</h3>

    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Nome da Coluna</label>
      </div>
      <div class="col-md-8">
        <input v-model="currentField.name" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Descrição</label>
      </div>
      <div class="col-md-8">
        <input v-model="currentField.description" class="form-control">
      </div>
    </div>

    <div class="row" v-if="isInput">
      <div class="col-md-4">
        <label class="float-right">Valor padrão (default)</label>
      </div>
      <div class="col-md-8">
        <input v-model="currentField.default" :type="currentField.type" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <BkpsCheckBox v-model="currentField.required" class="float-right mr-2"/>
      </div>
      <div class="col-md-8">
        <label for="">Obrigatório</label>
      </div>
    </div>

    <ReferencedField :field="currentField" v-if="!isInput"/>
    
    <hr>
    <button class="btn btn-success mr-1" @click="apply()">Aplicar</button>
    <button class="btn btn-outline mr-1" @click="closeModal()">Cancelar</button>

  </Modal>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import Modal from '@/components/shares/specialTag/Modal'
  import ReferencedField from './ReferencedField'

  export default {
    components: { BkpsCheckBox, Modal, ReferencedField },
    computed: {
      isInput() {
        return ['text', 'number'].includes(this.currentField.type)
      },
      visible() {
        return this.currentField && this.value
      },
    },
    created() {
      this.loadCurrentField()
    },
    data() {
      return {
        currentField: {},
        types: [
          { label: 'Texto', value: 'text' },
          // { label: 'Numérico', value: 'number' },
          { label: 'Referenciado', value: 'referenced' },
        ],
      }
    },
    methods: {
      apply() {
        Object.assign(this.field, this.currentField)
        this.$emit('setField')
        this.closeModal()
      },
      closeModal() {
        this.currentField = {}
        this.$emit('input', false)
      },
      loadCurrentField() {
        this.currentField = {...this.field}

        if (!('type' in this.currentField))
          this.$set(this.currentField, 'type', 'text')

        if (!('options' in this.currentField))
          this.$set(this.currentField, 'options', [])
      },
    },
    name: 'Field',
    props: {
      field: { required: true, type: Object },
      value: { default: false, type: Boolean }
    },
    watch: {
      visible(newValue) {
        if (newValue)
          this.loadCurrentField()
      }
    }
  }
</script>

<style scoped>

  .table td {
    padding: 8px;
  }

</style>